import React from 'react';
import Link from 'next/link';
import { ChevronDown } from 'lucide-react';

// import { ChevrondownSvg, CrossBlackIcon } from "@/src/Asset";
import useExploreMoreHook from './useExploreMoreHook';

const ExploreMore = ({ streamData, isTransparent, scroll }: any) => {
  const {
    dropdownRef,
    setShowDropdown,
    showDropdown,
    dropdownRef2,
    isHovering,
    handleCloseDropdown,
    sections,
    streams,
    handleStreamSelect,
    setSelectedStreamIndex,
    selectedStreamIndex,
  } = useExploreMoreHook({ streamData });

  return (
    <div
      className={`relative hidden lg:flex items-center gap-x-2 font-inter text-sm font-light cursor-pointer h-full
        ${isTransparent && scroll ? 'text-white' : 'text-black'}`}
      ref={dropdownRef}
    >
      <div
        className={`flex items-center gap-x-1 w-full tracking-tight text-sm 2xl:text-base 2xl:ml-4 px-4 py-2.5 rounded-full font-medium ${
          isTransparent && scroll ? 'text-white bg-white bg-opacity-10' : 'text-black bg-black bg-opacity-5'
        }`}
      >
        <button onClick={() => setShowDropdown(!showDropdown)}>
          Explore now
          {/* <ChevrondownSvg className="inline-block ml-1 !w-4 " /> */}
          <ChevronDown className="inline-block ml-1 size-5 w-4" />
        </button>
      </div>
      <div
        ref={dropdownRef2}
        className={`absolute flex min-h-full top-20 -left-2/3 mt-2 lg:w-[65rem] 2xl:w-[75rem] max-h-screen bg-white text-black rounded-md shadow-lg transition-opacity duration-300 cursor-default ${
          isHovering || showDropdown ? 'opacity-100 block' : 'opacity-0 hidden'
        }`}
      >
        {/* Arrow on top */}
        <div className="absolute top-[-12px] left-[18%] translate-x-[50%] w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[12px] border-b-white"></div>

        {/* Close Button */}
        <button
          className="absolute top-4 right-4 cursor-pointer text-gray-400 hover:text-black"
          onClick={handleCloseDropdown}
        >
          {/* <CrossBlackIcon /> */}
        </button>

        <div className="flex h-full w-full min-h-[70vh] max-h-[70vh]">
          {/* Left Navigation Pane */}
          <div className="w-1/6 border-r  bg-secondary-white pl-4 py-3 rounded-l-md">
            <ul className="space-y-2 h-full flex flex-col justify-start overflow-y-auto hide-scrollbar">
              {streams?.length > 0 ? (
                streams?.map((stream: any) => {
                  return (
                    <li key={stream?.id} className="h-fit font-inter">
                      <button
                        type="button"
                        className={`text-sm cursor-pointer w-full text-left ${
                          stream?.id === selectedStreamIndex ? 'text-primary font-medium' : 'hover:text-primary'
                        }`}
                        onClick={() => handleStreamSelect(stream?.id)}
                        onMouseEnter={() => setSelectedStreamIndex(stream?.id)}
                      >
                        {stream.stream_name}
                      </button>
                    </li>
                  );
                })
              ) : (
                <li>No streams available</li>
              )}
            </ul>
          </div>

          {/* Main Content */}
          <div className="w-4/5 pl-6 grid grid-cols-11 gap-8 max-h-full overflow-auto py-6 hide-scrollbar">
            {sections?.map(({ id, title, items, key, getUrl, viewAllUrl }: any) => {
              const limit = id === 1 ? 15 : 18;
              const displayedItems = items.length > limit ? items.slice(0, limit) : items;

              return (
                displayedItems?.length > 0 && (
                  <div className={`flex flex-col ${id === 1 ? 'col-span-3 row-span-3' : 'col-span-2'}`} key={id}>
                    <p className="text-primary text-sm font-inter font-semibold mb-4">{title}</p>
                    <ul className="space-y-2">
                      {displayedItems?.map((item: any, idx: number) =>
                        item[key] ? (
                          <li
                            key={item.id ?? idx}
                            className="text-sm tracking-tight text-black font-normal hover:text-primary flex items-start gap-1"
                          >
                            <Link
                              href={getUrl(item)}
                              className="hover:text-primary text-black font-normal text-xs"
                              onClick={handleCloseDropdown}
                            >
                              {item[key]}
                            </Link>
                          </li>
                        ) : null,
                      )}
                    </ul>

                    {(id === 1 && items.length > 15) || (id !== 0 && items.length > 6 && id !== 2 && id !== 5) ? (
                      <Link
                        href={viewAllUrl}
                        className="text-blue-500 mt-2 text-left text-xs ml-2"
                        onClick={handleCloseDropdown}
                      >
                        View All
                      </Link>
                    ) : null}
                  </div>
                )
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreMore;
